var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconActivityFeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g681ksp3va",
    d: "M12.6 2c5.523 0 10 4.477 10 10s-4.477 10-10 10v-2c4.418 0 8-3.582 8-8s-3.582-8-8-8c-4.08 0-7.446 3.054-7.938 7H5.8c.22 0 .4.18.4.4 0 .087-.028.17-.08.24l-2.2 2.933c-.133.177-.383.213-.56.08-.03-.022-.057-.05-.08-.08l-2.2-2.933c-.133-.177-.097-.427.08-.56.07-.052.153-.08.24-.08h1.25c.501-5.053 4.765-9 9.95-9zm4 12v2h-8v-2h8zm0-3v2h-8v-2h8zm0-3v2h-8V8h8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.000000, -348.000000) translate(0.000000, 336.000000) translate(24.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g71ifzdkvb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g681ksp3va"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 0.87,
    mask: "url(#g71ifzdkvb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActivityFeed);
export default __webpack_public_path__ + "static/media/icon-activity-feed.b6bcc6ecf03168d815248d9d179fa872.svg";
export { ForwardRef as ReactComponent };